<template>
  <div class="container mb-5">
    <div class="text-start">
      <h1 class="game-title gt-2 mb-0 pb-0">Leaderboards</h1>
    </div>
    <div class="border-game"></div>
    <div class="mb-4"></div>
    <div class="row">
      <div
        v-for="board in leaderboardContent"
        :key="board.id"
        class="col-12 col-lg-6 mb-5"
      >
        <LeaderboardCard
          :title="`${board.title}`"
          :selectedTimeFilter="board.timeFilter"
          :selectedLeaderboardFilter="board.leaderboardFilter"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LeaderboardCard from "@/components/activity/LeaderboardCard.vue";
import leaderboardContent from "@/data/leaderboards.json";

export default {
  name: "LeaderboardView",
  components: { LeaderboardCard },
  data() {
    return {
      leaderboardContent
    };
  }
};
</script>
